import UtilService from "../../service/UtilService";
import { useImmer } from "use-immer";
import { useEffect, useRef } from "react";

const Component = ({ configId, tresholdConfig, manualConfig, onChange }) => {
  const [state, updateState] = useImmer({
    values: tresholdConfig || {},
    manual: manualConfig || {},
  });

  const baselineRef = useRef(tresholdConfig || {});
  const manualBaselineRef = useRef(manualConfig || {});
  const hasInitManualBaseline = useRef(false);

  useEffect(() => {
    baselineRef.current = tresholdConfig || {};
    hasInitManualBaseline.current = false;
  }, [configId]);

  useEffect(() => {
    if (!UtilService.shallowEqual(state.values, tresholdConfig || {})) {
      updateState((d) => {
        d.values = tresholdConfig || {};
      });
    }
  }, [tresholdConfig]);

  useEffect(() => {
    const incoming = manualConfig || {};
    if (!UtilService.shallowEqual(state.manual, incoming)) {
      updateState((d) => {
        d.manual = incoming;
      });
    }
    if (!hasInitManualBaseline.current) {
      manualBaselineRef.current = incoming;
      hasInitManualBaseline.current = true;
    }
  }, [manualConfig]);

  const propagate = (nextValues, nextManual) =>
    onChange?.({ tresholdConfig: nextValues, manualConfig: nextManual });

  const handleValueChange = (key, raw) => {
    const value = raw === "" ? "" : Number.parseFloat(raw);

    const nextValues = { ...state.values, [key]: value };
    const nextManual = { ...state.manual };

    const wasManualAtLoad = Object.prototype.hasOwnProperty.call(
      manualBaselineRef.current,
      key,
    );

    if (UtilService.equalish(value, baselineRef.current?.[key])) {
      if (wasManualAtLoad) {
        nextManual[key] = value;
      } else {
        delete nextManual[key];
      }
    } else {
      nextManual[key] = value;
    }

    updateState((d) => {
      d.values = nextValues;
      d.manual = nextManual;
    });

    propagate(nextValues, nextManual);
  };

  const handleManualToggle = (key, checked) => {
    let nextManual;
    if (checked) {
      nextManual = { ...state.manual, [key]: state.values[key] };
    } else {
      const { [key]: _omit, ...rest } = state.manual;
      nextManual = rest;
    }

    updateState((d) => {
      d.manual = nextManual;
    });

    propagate(state.values, nextManual);
  };

  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Treshold name</th>
          <th>Value</th>
          <th>Simulation type</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(state.values).map(([key, value]) => {
          const isManual = Object.prototype.hasOwnProperty.call(
            state.manual,
            key,
          );

          return (
            <tr key={key}>
              <td>{UtilService.camelCaseToReadable(key)}</td>
              <td>
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  value={value}
                  onChange={(e) => handleValueChange(key, e.target.value)}
                />
              </td>
              <td style={{ textAlign: "left" }}>
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div className="fa-align-left">
                    <input
                      type="checkbox"
                      checked={isManual}
                      onChange={(e) =>
                        handleManualToggle(key, e.target.checked)
                      }
                    />
                  </div>
                  {/*<span style={{ fontSize: 12, opacity: 0.8 }}>*/}
                  {isManual ? "manually set" : "auto-calculated"}
                  {/*</span>*/}
                </label>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Component;
